import {
  GetSupplierProductByMainNo,
  GetStockInfoByScanInfo
} from '@/api'

export default {
  name: 'ScanMixin',
  data () {
    return {
      // 扫码框焦点
      scanInputIsfocus: false,
      // 是否扫码界面
      showCode: false,
      // 扫码次数
      count: 0,
      // 扫到的码
      code: '',
      // 上次时间
      lastTime: 0,

      tableCode: ''
    }
  },
  mounted () {
    this.tableCode = this.$route.name.replace('Edit', '')

    window.addEventListener("keypress", this.init, true)
  },
  destroyed () {
    window.removeEventListener("keypress", this.init, true)
  },

  methods: {
    // 扫码相关
    init (e) {
      var currCode = e.which;
      var currTime = new Date().getTime();
      if (this.lastTime > 0) {
        if (currTime - this.lastTime <= 100) {
          // this.code += String.fromCharCode(currCode);
        } else {
          // if (currTime - this.lastTime > 1000) {
          // 超时清空
          this.clearCode();
        }
        this.code += String.fromCharCode(currCode);
      }
      // 第一次按键
      else {
        this.code = String.fromCharCode(currCode);
      }
      this.lastTime = currTime;
      // 遇到回车
      if (currCode == 13 && this.isScan && !this.scanInputIsfocus) {
        // alert(code); // 这里得到码，做下一步业务处理
        this.mainNoChange(this.code)
        // console.log("123456789")
        // 回车输入后清空
        this.clearCode();
      }
    },
    clearCode () {
      this.code = '';
      this.lastTime = 0;
    },
    mainNoChange (val) {
      // 去掉空格
      val = val.replace(/\s+/g, "").toUpperCase()
      if (!val || val == '') {
        return;
      }

      if (this.count === 0) {
        if (this.childForm.mainNo && this.childForm.traceNo) {
          let valid = this.pushChildForm(false)
          if (!valid) {
            this.code = '';
            this.childForm.no = ''
            return
          }
        }
        this.getSupplierProductByMainno(val)
      }
      else {
        if (val == this.childForm.mainNo) {
          this.$my_message('主码和追溯码不能相同', 'warning')
          return
        }
        var traceNo = val
        if (this.childForm.mainNo) {
          traceNo = val.startsWith(this.childForm.mainNo) ? val.substr(this.childForm.mainNo.length, val.length - this.childForm.mainNo.length) : val
        }
        this.getSupplierByTraceNo(traceNo)
      }
    },
    getSupplierProductByMainno (no) {
      var reg = RegExp(`^${this.childForm.mainNo}`)
      if (no == this.childForm.mainNo || (reg.exec(no) && this.childForm.mainNo && this.childForm.mainNo != '')) {
        this.count++
        this.childForm.no = ''
        return;
      }
      this.resetDetailFormData()
      GetSupplierProductByMainNo({ mainNo: no })
        .then(res => {
          if (!res.successful) {
            return
          }
          // this.childForm = this.mapper.OutStockSupplierProduct2Form(this.childForm, res.returnData)
          this.childForm = Object.assign(this.childForm, res.returnData);
          
          this.childForm.orgCode = sessionStorage.getItem('orgId')
          this.childForm.supplierProductId = res.returnData.id
          this.childForm.supplierProductNo = res.returnData.no
          this.childForm.number = 0
          this.childForm.price = this.childForm.purchasePrice
          this.childForm.amount = 0
          this.childForm.mainNo = this.childForm.countryNo
          this.childForm.remark = ''
          this.childForm.packNumber = res.returnData.packNumber?res.returnData.packNumber:0
          if (this.tableCode == 'CollectOutStock') {
            this.childForm.price = res.returnData.billingPrice
            this.childForm.purchasePrice = res.returnData.purchasePrice
            // this.childForm.purchaseAmount = res.returnData.purchasePrice
          }
          this.count++
          this.childForm.no = ''
        })
    },
    getSupplierByTraceNo (no) {
      console.log(no, this.form.chargeDeptId, "getSupplierByTraceNo")
      if (this.childForm.traceNo == no && this.childForm.number > 0) {
        this.childForm.number = this.childForm.number * 1 + 1
        this.childForm.amount = this.childForm.number * this.childForm.price
        this.count--
        this.childForm.no = ''
        return;
      }
      // 盘点单
      if (this.tableCode == 'Inventory' && this.childForm.traceNo == no && this.childForm.inventoryNumber > 0) {
        this.childForm.inventoryNumber = this.childForm.inventoryNumber * 1 + 1
        this.childForm.diffNumber = this.childForm.inventoryNumber - this.childForm.stockNumber * 1
        this.childForm.result = this.childForm.diffNumber < 0 ? '盘亏' : this.childForm.diffNumber > 0 ? '盘盈' : '正常'
        this.childForm.amount = this.childForm.inventoryNumber * this.childForm.price
        this.count--
        this.childForm.no = ''
        return;
      }

      //添加行
      let arr = this.form.details.filter(item => item.mainNo == this.childForm.mainNo && item.traceNo == no)
      // this.childForm.traceNo = no

      // 添加行记录
      if (arr.length > 0) {
        // 存在则把列表的数据拿过来，并且数量加1
        this.form.details = this.form.details.map(item => {
          if (item.mainNo == this.childForm.mainNo && item.traceNo == no) {
            this.childForm.orgCode = sessionStorage.getItem('orgId')
            this.childForm.stockId = item.stockId
            this.childForm.supplierId = item.supplierId
            this.childForm.supplierName = item.supplierName
            this.childForm.packSpec = item.packSpec
            this.childForm.traceNo = item.traceNo
            this.childForm.manufactureDate = item.manufactureDate
            this.childForm.batch = item.batch
            this.childForm.validityDate = item.validityDate
            this.childForm.serialNo = item.serialNo
            this.childForm.locationId = item.locationId
            this.childForm.locationName = item.locationName
            this.childForm.outLocationId = item.locationId
            this.childForm.outLocationName = item.locationName
            this.childForm.stockNumber = item.stockNumber
            this.childForm.stockCategory = item.stockCategory
            this.childForm.stockCategoryName = item.stockCategoryName
            this.childForm.manufacturerId = item.manufacturerId
            this.childForm.manufacturerName = item.manufacturerName

            this.childForm.number = item.number * 1 + 1
            this.childForm.price = item.price
            this.childForm.billingPrice = item.billingPrice
            this.childForm.purchasePrice = item.purchasePrice
            this.childForm.amount = this.childForm.number * this.childForm.price
            this.childForm.purchaseAmount = this.childForm.number * this.childForm.purchasePrice
            if (this.tableCode == 'Inventory') {
              this.childForm.inventoryNumber = item.inventoryNumber * 1 + 1
              this.childForm.diffNumber = this.childForm.inventoryNumber - item.stockNumber * 1
              this.childForm.amount = this.childForm.inventoryNumber * this.childForm.price
              this.childForm.result = this.childForm.diffNumber < 0 ? '盘亏' : this.childForm.diffNumber > 0 ? '盘盈' : '正常'
            }
          }
          return item
        })

        this.count--
        this.childForm.no = ''
      } else {
        // 不存在则调用扫码解析，解析成功添加行记录
        let warehouseId = this.form.warehouseId
        if (this.tableCode == 'StockTransfer') {
          warehouseId = this.form.outWarehouseId
        }
        let category = 0
        let deptId;
        if (this.tableCode == 'StockUpUse' || this.tableCode == 'StockUpRefund') {
          category = 1
          deptId = this.form.deptId
        }
        if (this.tableCode == 'SurgicalUse' || this.tableCode == 'SurgicalRefund') {
          category = 2
        }
        if (this.tableCode == 'DeptUseOutStock') {
          category = 3
          // deptId = this.form.chargeDeptId
        }
        if (this.tableCode == 'LossOutStock') {
          category = this.form.stockCategory
        }

        GetStockInfoByScanInfo({ traceNo: no, warehouseId: warehouseId, mainNo: this.childForm.mainNo, category, deptId, tableCode: this.tableCode,
          supplierProductId:this.childForm.supplierProductId
         })
          .then(res => {
            if (!res.successful) {
              this.childForm.$index = this.form.details.length + 1
              this.childForm.stockId = ''
              this.childForm.supplierId = ''
              this.childForm.supplierName = ''
              this.childForm.packSpec = ''
              this.childForm.number = 0
              this.childForm.amount = 0
              this.childForm.purchaseAmount = 0
              this.childForm.traceNo = ''
              this.childForm.manufactureDate = ''
              this.childForm.batch = ''
              this.childForm.validityDate = ''
              this.childForm.serialNo = ''
              this.childForm.locationId = ''
              this.childForm.locationName = ''
              // 调拨
              this.childForm.outLocationId = ''
              this.childForm.outLocationName = ''
              this.childForm.stockCategory = ''
              this.childForm.stockCategoryName = ''
              // 盘点
              this.childForm.stockNumber = 0
              this.childForm.inventoryNumber = 0
              this.childForm.diffNumber = 0
              this.childForm.result = '正常'
              return
            }
            this.count--
            this.childForm.no = ''
            this.childForm.$index = this.form.details.length + 1
            this.childForm.stockId = res.returnData.id
            this.childForm.supplierId = res.returnData.supplierId
            this.childForm.supplierName = res.returnData.supplierName
            this.childForm.packSpec = res.returnData.packSpec
            this.childForm.price = res.returnData.price
            this.childForm.number = 1
            this.childForm.billingPrice = res.returnData.billingPrice
            this.childForm.stockCategory = res.returnData.stockCategory
            this.childForm.productRegistCertId = res.returnData.productRegistCertId
            this.childForm.productRegistCertNo = res.returnData.productRegistCertNo
            this.childForm.productRegistCertName = res.returnData.productRegistCertName
            this.childForm.manufacturerId = res.returnData.manufacturerId
            this.childForm.manufacturerName = res.returnData.manufacturerName
            this.childForm.orgCode = sessionStorage.getItem('orgId')
            if (this.tableCode == 'CollectOutStock') {
              this.childForm.price = res.returnData.billingPrice
              this.childForm.purchasePrice = res.returnData.price
              this.childForm.purchaseAmount = this.childForm.number * this.childForm.purchasePrice
            }

            this.childForm.amount = this.childForm.price
            this.childForm.traceNo = res.returnData.traceNo
            this.childForm.manufactureDate = res.returnData.manufactureDate
            this.childForm.batch = res.returnData.batch
            this.childForm.validityDate = res.returnData.validityDate
            this.childForm.serialNo = res.returnData.serialNo
            this.childForm.locationId = res.returnData.locationId
            this.childForm.locationName = res.returnData.locationName
            this.childForm.stockNumber = res.returnData.stockQuantity
            this.childForm.stockCategory = res.returnData.stockCategory
            this.childForm.stockCategoryName = res.returnData.stockCategoryName
            // 调拨
            this.childForm.outLocationId = res.returnData.locationId
            this.childForm.outLocationName = res.returnData.locationName
            // 盘点
            if (this.tableCode == 'Inventory') {
              this.childForm.inventoryNumber = 1
              this.childForm.diffNumber = 1 - res.returnData.stockQuantity
              this.childForm.amount = this.childForm.inventoryNumber * this.childForm.price
              this.childForm.result = this.childForm.diffNumber < 0 ? '盘亏' : this.childForm.diffNumber > 0 ? '盘盈' : '正常'
            }

          })
      }
    },


    

    scanInputFocus () {
      this.$forceUpdate()
      this.scanInputIsfocus = true
    },
    scanInputBlur () {
      this.$forceUpdate()
      this.scanInputIsfocus = false
    },
  }
}
